module.exports = __webpack_public_path__ + "static/media/btm.985d8c97.svg";